<template>
  <div class="channel-four-news">
    <!-- 卡片 / 列表 切换 -->
    <div class="view-toggle flex-row">
      <div
        class="toggle-btn"
        :class="{ active: viewMode === 'card' }"
        @click="switchView('card')"
      >
        <img
          class="toggle-icon"
          referrerpolicy="no-referrer"
          :src="require('../channel-four/img/FigmaDDSSlicePNG4d6effc257c8cf415a5617b2bdc6f6d5.png')"
        />
        <span>卡片</span>
      </div>
      <div
        class="toggle-btn"
        :class="{ active: viewMode === 'list' }"
        @click="switchView('list')"
      >
        <img
          class="toggle-icon"
          referrerpolicy="no-referrer"
          :src="require('../channel-four/img/FigmaDDSSlicePNGa5902adc8863461133bbe9fb0ac41fdf.png')"
        />
        <span>列表</span>
      </div>
    </div>

    <!-- 新闻内容 -->
    <div class="news-content" v-if="newsList.length > 0">
      <!-- 卡片视图：每行 4 个，每个 238x330 -->
      <div v-if="viewMode === 'card'" class="news-card-list">
        <div
          class="news-card"
          v-for="(item, index) in newsList"
          :key="'card-' + index"
        >
          <div class="card-image-wrap" @click="goDetail(item.newsCode)" >
            <img
              class="card-image"
              referrerpolicy="no-referrer"
              :src="item.img"
              :alt="item.title"
              @error="handleCardImageError(index)"
              @load="handleImageLoad(item.id)"
              :class="{ 'img-loading': !item.loaded }"
            />
            <span v-if="!item.loaded && item.isLoading" class="img-placeholder">加载中...</span>
          </div>
          <div class="card-info">
            <span class="card-time">{{ getSource(item.source) }}</span>
            <span class="card-time-wrapper">&nbsp;|&nbsp;{{ formatTime(item.time) }}</span>
          </div>
          <div class="card-title" @click="goDetail(item.newsCode)">{{ item.title }}</div>
          <div class="card-actions flex-row" style="margin-top: 30px;">
            <ShareButton :news-code="item.newsCode" :title="item.title" />
            <FavoriteButton :news-id="item.id" />
          </div>
        </div>
      </div>

      <!-- 列表视图 -->
      <div v-else class="news-list-view">
        <div
          class="news-list-item flex-row"
          v-for="(item, index) in newsList"
          :key="'list-' + index"
        >
          <div class="list-image-wrap" @click="goDetail(item.newsCode)" v-if="item.img && item.img !== 'https://image.cbrand.com.cn/default/2026/10/AA38368160C540F19F19189B1D3A82AE.png'">
            <img
              class="list-image"
              referrerpolicy="no-referrer"
              :src="item.img || DEFAULT_IMAGE"
              :alt="item.title"
              @error="handleImageError($event, item.img)"
              @load="handleImageLoad(item.id)"
              :class="{ 'img-loading': !item.loaded }"
            />
            <span v-if="!item.loaded && item.isLoading" class="img-placeholder">加载中...</span>
          </div>
          <div class="list-info flex-col">
            <div class="list-title" @click="goDetail(item.newsCode)">{{ item.title }}</div>
            <p class="list-desc">{{ item.desc }}</p>
            <div class="list-bottom flex-row">
              <div class="list-meta flex-row">
                <span class="list-time">{{ getSource(item.source) }}</span>&nbsp;|&nbsp;
                <span class="list-time">{{ formatTime(item.time) }}</span>
              </div>
              <div class="list-actions flex-row">
                <ShareButton :news-code="item.newsCode" :title="item.title" />
                <FavoriteButton :news-id="item.id" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载更多 / 没有更多 -->
    <div class="news-load-more" v-if="hasMore" @click="loadMore">
      <span v-if="!loading">加载更多</span>
      <span v-else>加载中...</span>
    </div>
    <div class="news-no-more" v-if="!hasMore && newsList.length > 0">
      <span>没有更多新闻数据</span>
    </div>
  </div>
</template>

<script>
import { fetchNewsListL2, mapNewsItem } from '../../../api'
import FavoriteButton from './FavoriteButton.vue'
import ShareButton from './ShareButton.vue'

export default {
  name: 'ChannelFourNews',
  components: { FavoriteButton, ShareButton },
  props: {
    categoryId: { type: [Number, String], default: null },
    excludeNewsIdList: { type: Array, default: () => [] }
  },
  data() {
    return {
      viewMode: 'card',
      newsList: [],
      page: 1,
      pageSize: 12,
      hasMore: true,
      loading: false,
      DEFAULT_IMAGE: 'https://image.cbrand.com.cn/default/2026/10/AA38368160C540F19F19189B1D3A82AE.png'
    }
  },
  watch: {
    categoryId(newVal) {
      if (newVal) {
        // categoryId 变化时重置并加载
        this.page = 1
        this.newsList = []
        this.hasMore = true
        this.fetchNews()
      }
    },
    excludeNewsIdList() {
      // 无论是否为空，都重新加载新闻列表（排除条件变化）
      this.page = 1
      this.newsList = []
      this.hasMore = true
      this.fetchNews()
    }
  },
  created() {
    // 页面创建时加载数据
    if (this.categoryId) {
      this.fetchNews()
    }
  },
  methods: {
    switchView(mode) {
      this.viewMode = mode
    },
    resetAndFetch() {
      this.page = 1
      this.newsList = []
      this.hasMore = true
      this.fetchNews()
    },
    async fetchNews() {
      if (this.loading || !this.categoryId) return
      this.loading = true
      try {
        const params = {
          categoryId: this.categoryId,
          pageNum: this.page,
          pageSize: this.pageSize
        }
        // 如果 excludeNewsIdList 有数据，添加到参数中
        if (this.excludeNewsIdList && this.excludeNewsIdList.length > 0) {
          params.excludeNewsIdList = this.excludeNewsIdList
          console.log('[ChannelFourNews] excludeNewsIdList:', this.excludeNewsIdList, 'params:', params)
        } else {
          console.log('[ChannelFourNews] excludeNewsIdList is empty:', this.excludeNewsIdList, 'params:', params)
        }
        const { list } = await fetchNewsListL2(params)
        const mapped = list.map(mapNewsItem)
        // 添加图片加载状态
        mapped.forEach(item => {
          item.loaded = false
          item.isLoading = true
          item.error = false
        })
        if (this.page === 1) {
          this.newsList = mapped
        } else {
          this.newsList = this.newsList.concat(mapped)
        }
        this.hasMore = mapped.length === this.pageSize
        this.page += 1
      } catch (e) {
        console.error('新闻加载失败', e)
      } finally {
        this.loading = false
      }
    },
    loadMore() {
      this.fetchNews()
    },
    formatTime(timeStr) {
      if (!timeStr) return timeStr
      const now = new Date()
      const time = new Date(timeStr)
      const diffMs = now.getTime() - time.getTime()
      const diffSecs = Math.floor(diffMs / 1000)
      const diffMins = Math.floor(diffSecs / 60)
      const diffHours = Math.floor(diffMins / 60)
      const diffDays = Math.floor(diffHours / 24)

      if (diffDays > 0) {
        return `${diffDays}天前`
      } else if (diffHours > 0) {
        return `${diffHours}小时前`
      } else if (diffMins > 0) {
        return `${diffMins}分钟前`
      } else {
        return '刚刚'
      }
    },
    goDetail(newsCode) {
      if (newsCode) {
        window.open(`/zp/a/${newsCode}`, '_blank')
      }
    },
    getSource(source) {
      if (!source) return ''
      const truncated = source.split('|')[0]
      return this.truncateSevenChars(truncated)
    },
    truncateSevenChars(str) {
      if (!str) return ''
      if (str.length <= 7) return str
      return str.slice(0, 7) + '...'
    },
    handleImageError(event, originalUrl) {
      console.warn(`图片加载失败：${originalUrl}，切换为默认图片`)
      event.target.src = this.DEFAULT_IMAGE
      event.target.error = true
    },
    handleCardImageError(index) {
      if (this.newsList[index]) {
        this.newsList[index].error = true
        this.newsList[index].isLoading = false
        this.newsList[index].img = this.DEFAULT_IMAGE
      }
    },
    handleImageLoad(itemId) {
      const item = this.newsList.find(i => i.id === itemId)
      if (item) {
        item.loaded = true
        item.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* 切换标签 */
.view-toggle {
  margin-top: 24px;
  margin-bottom: 20px;
}

.toggle-btn {
  width: 80px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.2s;
}

.toggle-btn:first-child {
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.toggle-btn:last-child {
  border-radius: 0 4px 4px 0;
}

.toggle-btn.active {
  background: #C00513;
  color: #fff;
  border-color: #C00513;
}

.toggle-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  object-fit: contain;
  filter: brightness(0.4) grayscale(100%);
}

.toggle-btn.active .toggle-icon {
  filter: brightness(0) invert(1);
}

/* 卡片视图：每行 4 个，固定 238x330 */
.news-card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 29px;
}

.news-card {
  width: 238px;
  height: 296px;
  background: rgba(245, 245, 247, 1);
  overflow: hidden;
  border: 1px solid rgba(226, 226, 227, 1);
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.card-image-wrap,
.card-title {
  cursor: pointer;
}

.news-card:hover {
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.news-card:hover .card-title {
  color: #C00513;
}

.card-image-wrap {
  position: relative;
  width: 100%;
  height: 133px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: opacity 0.3s ease;
}

/* 加载中状态 */
.img-loading {
  opacity: 0.3;
}

.card-info {
  display: flex;
  align-items: center;
  margin: 14px 14px 0;
  font-size: 12px;
  color: #999;
}

.card-category {
  max-width: 118px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999;
}

.card-time-wrapper {
  color: #999;
}

.card-time {
  color: #999;
}

.card-title {
  font-size: 18px;
  color: #333;
  line-height: 30px;
  margin: 8px 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 60px;
  box-sizing: border-box;
  transition: color 0.2s;
}

.card-actions {
  margin: auto 14px 16px;
  gap: 24px;
}

.action-item {
  align-items: center;
  margin-right: 20px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
}

.action-item:hover {
  color: #C00513;
}

.action-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  object-fit: contain;
}

/* 列表视图 */
.news-list-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.news-list-item {
  padding: 16px;
  background: rgba(245, 245, 247, 1);
  border-radius: 4px;
  transition: all 0.2s ease;
  height: 152px;
}

.list-image,
.list-title {
  cursor: pointer;
}

.news-list-item:hover {
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.news-list-item:hover .list-title {
  color: #C00513;
}

.list-image {
  width: 213px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
  margin-right: 16px;
}

.list-image-wrap {
  position: relative;
  display: inline-block;
}

/* 加载中状态 - 占位符居中显示 */
.img-placeholder,
.img-default {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #999;
  z-index: 1;
}

.list-info {
  flex: 1;
  min-width: 0;
  justify-content: space-between;
}

.list-title {
  font-size: 18px;
  color: #333;
  line-height: 1.5;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.2s;
}

.list-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin: 8px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  margin-top: 12px;
  justify-content: space-between;
  align-items: center;
}

.list-meta {
  font-size: 13px;
  color: #999;
}

.list-category {
  max-width: 118px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999;
}

.list-actions {
  gap: 20px;
}

/* 加载更多 */
.news-load-more {
  margin-top: 30px;
  text-align: center;
  padding: 14px 0;
  background: #fff;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.news-load-more:hover {
  color: #C00513;
  border-color: #C00513;
}

/* 没有更多 */
.news-no-more {
  margin-top: 30px;
  text-align: center;
  padding: 14px 0;
  color: #999;
  font-size: 14px;
}
</style>
